import React from 'react';
import { Box, Card, Text } from '@nimbus-ds/components';

function BalanceCardSkeleton(): JSX.Element {
  return (
    <Card>
      <Box display="flex" justifyContent="space-between" flexDirection="row">
        <Text.Skeleton />
        <Text.Skeleton />
      </Box>
    </Card>
  );
}

export default BalanceCardSkeleton;
